import { TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { IMaskInput } from 'react-imask';
import * as React from 'react';

interface PropsInterface {
    name: string;
    label: string;
    rules?: any;
    [x: string]: any;
}

const TextMaskPhone = React.forwardRef<HTMLElement, any>(
    function TextMaskPhone(props, ref) {
        const { onChange, ...other } = props;
        return (
            <IMaskInput
                {...other}
                mask="(#00) 000-0000"
                definitions={{
                    '#': /[1-9]/,
                }}
                //inputRef={ref}
                onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
                overwrite
            />
        );
    },
);

export const InputFormMaskTel = ({ name, label, rules, ...props }: PropsInterface) => {
    const { control, formState } = useFormContext();
    const errors = formState?.errors[name]
        ? formState.errors[name]?.message?.toString()
        : "";
    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange, value } }) => (
                <TextField
                    label={label}
                    onChange={onChange}
                    value={value || ""}
                    error={formState.errors[name] ? true : false}
                    {...props}
                    helperText={errors}
                    placeholder='(000) 000-0000'
                    id="formatted-text-mask-input"
                    InputProps={{
                        inputComponent: TextMaskPhone as any,
                    }}
                />
            )}
            rules={rules}
        />
    );
};
